// extracted by mini-css-extract-plugin
export default {"searchPage":"Search_searchPage__f68u7","pageSidebar":"Search_pageSidebar__Kbk-M"};